import { ApiClient } from '../../client';
import { FacilityQTAStatusCounts, Metrics } from './types';

export class MetricsService {
  constructor(private api: ApiClient) {}

  async getFacilityQTAStatusCounts() {
    return this.api.get<FacilityQTAStatusCounts>(
      '/metrics/facility-qta-status-counts'
    );
  }

  async getAll() {
    return this.api.get<Metrics>('/metrics');
  }
}
